import script from "./Analytics.vue?vue&type=script&setup=true&lang=js"
export * from "./Analytics.vue?vue&type=script&setup=true&lang=js"

import "./Analytics.vue?vue&type=style&index=0&id=61022a8c&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61022a8c"]])

export default __exports__